import { Outlet } from 'react-router';

import { SessionExpiredBridge } from '@/components/layout/session-expired-bridge';
import { SidebarBrand } from '@/components/layout/sidebar-brand';
import { SidebarFooterSlot } from '@/components/layout/sidebar-footer-slot';
import { SidebarNav } from '@/components/layout/sidebar-nav';
import { TopBar } from '@/components/layout/top-bar';
import { UserMenu } from '@/components/layout/user-menu';
import { Sidebar, SidebarProvider } from '@/components/ui/sidebar';
import { SidebarInset } from '@/components/ui/sidebar-sections';
import { useCurrentUser } from '@/features/auth';
import { ImpersonationBanner } from '@/features/impersonation';
import { InvoiceDetailDrawer } from '@/features/invoicing';
import { FeatureFlagIdentity } from '@/lib/feature-flags';

// During impersonation the LD identity stays the real admin (impersonatedBy),
// not the impersonated target — flag targeting follows who is driving.
function FeatureFlagIdentityBridge() {
  const { user } = useCurrentUser();
  return <FeatureFlagIdentity userKey={user ? (user.impersonatedBy ?? user.id) : null} />;
}

export function AppShell() {
  return (
    <SidebarProvider>
      <SessionExpiredBridge />
      <FeatureFlagIdentityBridge />
      <Sidebar collapsible="icon">
        <SidebarBrand />
        <SidebarNav />
        <SidebarFooterSlot>
          <UserMenu />
        </SidebarFooterSlot>
      </Sidebar>
      <SidebarInset className="min-w-0">
        <div className="sticky top-0 z-30">
          <ImpersonationBanner />
          <TopBar sticky={false} />
        </div>
        <Outlet />
      </SidebarInset>
      <InvoiceDetailDrawer />
    </SidebarProvider>
  );
}
